import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import FormGridRow from "../../../../common/components/functional/formGridRow/FormGridRow";
import CommonTextField from "../../../../common/components/functional/commonTextField/CommonTextField";
import { validateCustomerNumber } from "../../utils";

export const CreateOrganizationForm = () => {
  const { t } = useTranslation(["customers", "common"]);

  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const businessIdDisabled = watch("businessIdDisabled");

  return (
    <Grid container spacing={2} sx={{ margin: "8px" }}>
      <FormGridRow
        label={t("businessId")}
        labelSize={3}
        fieldSize={9}
        GridLabelProps={{ sx: { alignItems: "top", marginTop: "8px" } }}
      >
        <Controller
          control={control}
          name="businessId"
          rules={{
            required: !businessIdDisabled,
          }}
          render={({ field }) => (
            <CommonTextField
              {...field}
              disabled={businessIdDisabled}
              sx={{ maxWidth: "372px" }}
              fullWidth
              error={!!errors.businessId}
              onChange={(e) => {
                const value = e.target.value.trim();
                field.onChange(value);
              }}
            />
          )}
        />
        <Controller
          control={control}
          name="businessIdDisabled"
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={field.value}
                  onChange={(e) => {
                    field.onChange(e.target.checked);
                  }}
                  size="small"
                />
              }
              label={t("noBusinessId")}
            />
          )}
        />
      </FormGridRow>
      <FormGridRow label={t("common:name")} labelSize={3} fieldSize={9}>
        <Controller
          control={control}
          name="name"
          rules={{ required: true }}
          render={({ field }) => (
            <CommonTextField
              {...field}
              sx={{ maxWidth: "372px" }}
              fullWidth
              error={!!errors.name}
            />
          )}
        />
      </FormGridRow>
      <FormGridRow label={t("customerNumber")} labelSize={3} fieldSize={9}>
        <Controller
          control={control}
          name="customerNumber"
          rules={{
            required: true,
            validate: validateCustomerNumber,
          }}
          render={({ field }) => (
            <CommonTextField
              {...field}
              sx={{ maxWidth: "372px" }}
              fullWidth
              error={!!errors.customerNumber}
              onChange={(e) => {
                const value = e.target.value.trim();
                field.onChange(value);
              }}
            />
          )}
        />
      </FormGridRow>
    </Grid>
  );
};
